import { render, staticRenderFns } from "./GetTriggerDetails.vue?vue&type=template&id=270308e2"
import script from "./GetTriggerDetails.vue?vue&type=script&lang=js"
export * from "./GetTriggerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports